<template>
  <div>
    <b-col>
      <b-row>
        <b-col>

          <h2>Sperrlisten</h2>

        </b-col>
        <b-col>
          <b-button
              size="sm"
              variant="primary"
              v-b-modal.modal-blocker-list-create
              @click="clearSelectedBlockerList()"
              class="my-2 float-right"
          >Liste erstellen</b-button>
        </b-col>
      </b-row>
    </b-col>

    <b-row v-if="!finishedLoading" align-v="center" class="m-4 p-2">
      <b-col/>
      <b-col align-h="center">
        <div ><b-spinner style="width: 4rem; height: 4rem;" label="loading..."/></div>
      </b-col>
      <b-col/>
    </b-row>
    <b-table 
        v-else 
        striped 
        hover 
        size="sm"
        class="table-sm"
        :fields="fields" 
        :items="blockerLists"
    ><!-- table -->

      <template v-slot:cell(message)="row">
        <span v-if="row.item.processingRequest" class="text-success float-right">
            <b>Anfrage läuft</b>
        </span>
        <div v-else>
          <span      v-if="row.item.listDeleted == true"                                                        class="float-right"><b>Sperrliste Wurde gelöscht.</b> </span>
          <span v-else-if="row.item.evaluationJob != null && row.item.evaluationJob.state  == 'failed'"         class="text-danger float-right"><b>Auswertung der Sperre ist fehlgeschlagen!</b> </span>
          <span v-else-if="row.item.evaluationJob != null && row.item.evaluationJob.state === 'mango_finished'" class="float-right"            >Mango-Queries fertig...</span>
          <span v-else-if="row.item.evaluationJob != null && row.item.evaluationJob.state === 'created'"        class="float-right"            >Sperre wird ausgewertet...</span>
        </div>
      </template>

      <template v-slot:cell(actions)="row">
        <div v-if="row.item.processingRequest || row.item.listDeleted"></div>
        <div v-else-if="row.item.evaluationJob != null && row.item.evaluationJob != undefined && row.item.evaluationJob.state === 'failed'"></div>
        <b-row class="float-right mr-1" v-else-if="(!row.item.processingRequest) && (row.item.evaluationJob == null || row.item.evaluationJob == undefined || row.item.evaluationJob.state === 'finished')">
          <b-button size="sm" v-b-modal.modal-blocker-list-edit variant="primary" @click="edit(row)" class="mr-1">
            <span class="icon icon-pencil"/>
          </b-button>
          <b-button size="sm" variant="secondary" @click="modalDelete.open(row.item.id)">
            <span class="icon icon-bin"/>
          </b-button>
        </b-row>

        <b-col v-else>
          <div class="float-right mr-1"><b-spinner class="mr-2 pr-1" style="width: 1rem; height: 1rem;" label="loading..."/></div>
        </b-col>

      </template>
      <template v-slot:cell(blackOrWhite)="row">
        <span v-if="row.item.blackOrWhite" class="text-danger">Sperrung</span>
        <span v-else class="text-success">Freigabe</span>
      </template>
      <template v-if="finishedLoading" v-slot:cell(place)="row">
        <span v-if="row.item.countryId">country <b>{{countries.find( country => country.id === row.item.countryId).name }}</b></span>
        <span v-else-if="row.item.marketId">market <b>{{markets.find( market => market.id === row.item.marketId).name }}</b></span>
        <span v-else-if="row.item.regionId">region <b>{{regions.find( region => region.id === row.item.regionId).name }}</b></span>
      </template>
    </b-table>
    <!--  @ok="$bvModal.show('modal-blocker-list-edit')" -->
    <b-modal
        id="modal-blocker-list-create"
        title="Sperrliste erstellen"
        cancel-title="Abbrechen"
        @ok="() => { show_modalBlockerListEdit = true; }"
        no-close-on-backdrop
        centered
        size="md"
    ><!-- modal -->
      <b-input-group>
        <b-form-input v-model="selectedBlockerList.name"/>
        <b-input-group-append>
          <b-button 
            @click="selectedBlockerList.blackOrWhite = !selectedBlockerList.blackOrWhite"
            variant="outline-secondary"
          ><!-- button -->
            <span v-if="selectedBlockerList.blackOrWhite" class="text-danger">Sperrung</span>
            <span v-else class="text-success">Freigabe</span>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>
    <b-modal id="modal-blocker-list-edit"
             v-model="show_modalBlockerListEdit"
             cancel-title="Abbrechen"
             @ok="saveBlockerList"
             @cancel="clearSelectedBlockerList()"
             no-close-on-backdrop
             centered
             size="xl"
    ><!-- b-modal -->
      <template v-slot:modal-title>
        <b-row>
          <b-input-group class="mx-3">
            <b-form-input v-model="selectedBlockerList.name"/>
            <b-input-group-append>
              <b-button
                @click="selectedBlockerList.blackOrWhite = !selectedBlockerList.blackOrWhite"
                variant="outline-secondary"
                :disabled="selectedBlockerList.id != undefined && selectedBlockerList.id != null"
              ><!-- button -->
                <span v-if="selectedBlockerList.blackOrWhite" class="text-danger">Sperrung</span>
                <span v-else class="text-success">Freigabe</span>
              </b-button>
            </b-input-group-append>
          </b-input-group>

        </b-row>
      </template>
      <template v-slot:modal-footer>
        <b-row>
          <span class="mr-2 mt-2">zuletzt bearbeitet von: <b>{{selectedBlockerList.username}}</b> am {{selectedBlockerList.updatedAtHumanReadable}}</span>
          <b-button @click="saveBlockerList" variant="primary" class="float-right mr-2">Speichern</b-button>
          <b-button @click="closeModalBlockerListEdit" variant="secondary" class="float-right">Abbrechen</b-button>
        </b-row>
      </template>

      <b-row>
        <b-col>
          <b-form-radio-group
              id="btn-radios-1"
              v-model="selectedBlockerList.place"
              :options="placeOptions"
              buttons
              button-variant="outline-primary"
              name="radios-btn-default"
          ></b-form-radio-group>
        </b-col>
        <b-col>
          <b-form-select
              v-if="selectedBlockerList.place === 'Land'"
              v-model="selectedBlockerList.countryId"
              :options="countrySelectOptions"
          />
          <b-form-select
              v-else-if="selectedBlockerList.place === 'Markt'"
              v-model="selectedBlockerList.marketId"
              :options="marketSelectOptions"
          />
          <b-form-select
              v-else-if="selectedBlockerList.place === 'Region'"
              v-model="selectedBlockerList.regionId"
              :options="regionSelectOptions"
          />
          <span v-else>Wählen Sie Land, Markt oder Region aus.</span>
        </b-col>
      </b-row>
      <hr>
      <b-col>
        <b-row>
          <span>Typ:</span>
          <b-form-select
              v-model="selectedBlockerList.type"
              :options="['ean', 'asin']"
              :disabled="selectedBlockerList.id != undefined && selectedBlockerList.id != null"
          />
        </b-row>
      </b-col>

      <hr>
      <span>Beschreibung:</span>
      <b-form-textarea v-model="selectedBlockerList.description" rows="3"/>
      <hr>
      <span>payload:</span>
      <b-form-textarea
          v-model="selectedBlockerListPayload"
          @focus="$event.target.select()"
          :state="validatePayload()"
          rows="15"
      />
    </b-modal>

        <b-modal 
        v-model="modalDelete.state"
        @ok="modalDelete.ok"
        @hidden="modalDelete.reset"
        centered
    >Wollen sie die Sperrung/Freigabe wirklich löschen?</b-modal>

  </div>
</template>
<script>
    import axios from 'axios';
    export default {
        name: "BlockerList",
        data()
        {
            return {
                user: null,
                timer: '',
                show_modalBlockerListEdit: false,
                modalBlockerListEdit: false, // what is the difference to show_modalBl...
                finishedLoading: false,
                blockerLists: [],
                countries: [],
                countrySelectOptions: [],
                regions: [],
                regionSelectOptions: [],
                markets: [],
                marketSelectOptions: [],
                fields: [
                  { key: 'name',         label: 'Name', sortable: true },
                  { key: 'blackOrWhite', label: 'Sperrung/Freigabe', sortable: true},
                  { key: 'username',     label: 'Benutzer', sortable: true },
                  { key: 'updatedAt',    label: 'geändert am', sortable: true , formatter: (s) => (s) ? moment(s).format('DD.MM.YY HH:mm') : '-'},
                  { key: 'place',        label: 'Region' },
                  { key: 'message',      label: ''},
                  { key: 'actions',      label: ''}
                ],
                placeOptions: ["Markt", "Region", "Land"],
                selectedBlockerList: {
                    name: "",
                    description: "",
                    blackOrWhite: 1,
                    username: null,
                    countryId: undefined,
                    marketId: undefined,
                    regionId: undefined
                },
                modalDelete: {
                  state: false,
                  blockerListId: null,
                  open: (id) => {
                    this.modalDelete.blockerListId = id;
                    this.modalDelete.state = true;
                  },
                  ok: () => {
                    this.blockerLists.find( x => x.id == this.modalDelete.blockerListId ).processingRequest = true;
                    axios.delete(`mds/blocker_list/${this.modalDelete.blockerListId}`).then( response => {
                        this.modalDelete.blockerListId = null;
                        alert(`Sperrliste wird gelöscht, dies kann einige Minuten (1-120 min.) dauern.`);
                    }).catch( error => {
                      alert(`Löschvorgang ist fehlgeschlagen: \n ${JSON.stringify(error)}`); // TODO
                      console.log(error);
                      this.modalDelete.blockerListId = null;
                    });
                  },
                  reset: () => {
                    this.modalDelete.blockerListId = null;
                  }
                },
                selectedBlockerListPayload: ''  //for some reason, this prop cannot be inside of selectedBF, changes aren't handled correctly.
            }
        },
        methods: {
            fetchData() {
                console.log("called fetchData")
                axios.get('/mds/evaluation_job')
                .then( response => {
                    this.blockerLists = this.blockerLists.map( bl => {
                        let many = response.data.filter( ej => ej.blockerListId === bl.id ).sort((a,b) => a.id <= b.id );
                        bl.evaluationJob = (many.length > 0) ? many[ many.length - 1 ] : null;
                        bl.processingRequest = false;
                        if(many.length == 0) bl.listDeleted = true;
                        return bl;
                      });
                })
                .catch(error => console.log(error));
            },
            validatePayload() {
                if(this.selectedBlockerListPayload === null) return false;
                if(this.selectedBlockerList.type === 'ean')
                {
                  return ((this.selectedBlockerListPayload.match(/^[0-9\n]+$/) != null) && (this.selectedBlockerListPayload.length !== 0));
                }
                else
                {
                  return true; //TODO maybe add validation for asin
                }
            },
            closeModalBlockerListEdit() {
               this.clearSelectedBlockerList();
               this.show_modalBlockerListEdit = false;
            },
            clearSelectedBlockerList() {
                this.selectedBlockerList = {
                    name: "",
                    description: "",
                    blackOrWhite: 1,
                    baseload: false,
                    countryId: undefined,
                    marketId: undefined,
                    regionId: undefined,
                    place: null
                };
                this.selectedBlockerListPayload = null;
            },
            edit(row)
            {
                this.selectedBlockerList = row.item;
                if(this.selectedBlockerList.updatedAt) {
                   this.selectedBlockerList.updatedAtHumanReadable = moment(this.selectedBlockerList.updatedAt).format('d.m.YY')
                                                                   + ' um: '
                                                                   + moment(this.selectedBlockerList.updatedAt).format('HH:mm');
                }
                if(typeof this.selectedBlockerList.payload === 'string') {
                   this.selectedBlockerListPayload = this.selectedBlockerList.payload; //Warning: byref
                }
                else
                {
                  // happens after saving last object and re-editing it. Should happen in axios request instead!
                  this.selectedBlockerListPayload = this.selectedBlockerList.payload.join('\n'); //Warning: byref
                }
                //choose place based on if country,region or marketId are set:
                if(this.selectedBlockerList.countryId)
                {
                    this.selectedBlockerList.place = 'Land';
                }
                else if(this.selectedBlockerList.marketId)
                {
                    this.selectedBlockerList.place = 'Markt';
                }
                else if(this.selectedBlockerList.regionId)
                {
                    this.selectedBlockerList.place = 'Region';
                }
            },
            saveBlockerList(evt)
            {
                if(!this.selectedBlockerList.type)
                {
                    alert("Bitte geben Sie einen Sperrlisten-Typ (EAN oder ASIN) an.");
                    this.modalBlockerListEdit = true;
                    evt.preventDefault();
                    return;
                }

                // if we are dealing with type.regex, then we need to copy selectedBlockerListPayload
                switch(this.selectedBlockerList.type)
                {
                  case 'ean':
                      // console.log("REGEX PATTERN", this.selectedBlockerListPayload.match(/^[0-9,\n]+$/));
                      if(this.selectedBlockerListPayload.match(/^[0-9,\n]+$/) == null)
                      {
                          // TODO show error alert and preventDefault()
                          alert("invalid input");
                          // this.$refs.modal_blocker_list_edit.preventDefault()
                          this.modalBlockerListEdit = true;
                          evt.preventDefault();
                          this.show_modalBlockerListEdit = false;
                          return;
                      }
                  break;
                  case 'asin':
                      // TODO we are currently not validating asins!
                  break;
                }

                // convert the payload to json-string, remove empty strings.
                this.selectedBlockerList.payload = this.selectedBlockerListPayload.split('\n').filter( x => x.length !== 0 );

                // this code block guarantees that we only set a single place id.
                if(this.selectedBlockerList.place === null) {
                 alert('Kein Land, Markt oder Region wurde ausgewählt.');
                 evt.preventDefault();
                 this.show_modalBlockerListEdit = true;
                 return;
                }
                else if(this.selectedBlockerList.place === 'Land')
                {
                    this.selectedBlockerList.marketId = null;
                    delete this.selectedBlockerList.marketId;
                    this.selectedBlockerList.regionId = null;
                    delete this.selectedBlockerList.regionId;
                    if(!this.selectedBlockerList.countryId) {
                        alert('no countryId selected. Aborting save.');
                        evt.preventDefault();
                        this.show_modalBlockerListEdit = true;
                        return;
                    }
                }
                else if (this.selectedBlockerList.place === 'Markt')
                {
                    this.selectedBlockerList.countryId = null;
                    delete this.selectedBlockerList.countryId;
                    this.selectedBlockerList.regionId = null;
                    delete this.selectedBlockerList.regionId;
                    if(!this.selectedBlockerList.marketId) {
                        alert('no marketId selected. Aborting save.');
                        evt.preventDefault();
                        this.show_modalBlockerListEdit = true;
                        return;
                    }
                }
                else if (this.selectedBlockerList.place === 'Region')
                {
                    this.selectedBlockerList.countryId = null;
                    delete this.selectedBlockerList.countryId;
                    this.selectedBlockerList.marketId = null;
                    delete this.selectedBlockerList.marketId;
                    if(!this.selectedBlockerList.regionId) {
                        alert('no regionId selected. Aborting save.');
                        evt.preventDefault();
                        this.show_modalBlockerListEdit = true;
                        return;
                    }
                }

                if (this.selectedBlockerList.id)
                {
                    this.selectedBlockerList.processingRequest = true;
                    axios.put(
                        `/mds/blocker_list`,
                        this.selectedBlockerList
                    ).then( response => {
                        this.clearSelectedBlockerList();
                        this.modalBlockerListEdit = false;
                        this.show_modalBlockerListEdit = false;
                        this.fetchData();
                    }).catch(error => {
                        alert(JSON.stringify(error));
                        console.log(error);
                    });
                }
                else
                {

                  if(typeof this.selectedBlockerList.payload === 'string')
                  {
                    this.selectedBlockerList.payload = JSON.parse(this.selectedBlockerListPayload);
                  }
                  this.selectedBlockerList.username = this.user.name;
                  this.selectedBlockerList.processingRequest = true;
                  axios.post(`/mds/blocker_list`, this.selectedBlockerList ).then( response =>
                  {
                    response.data.blockerList.payload = JSON.parse(response.data.blockerList?.payload).join('\n');
                    this.blockerLists.push(response.data.blockerList);
                    this.clearSelectedBlockerList();
                    this.modalBlockerListEdit = false;
                    this.show_modalBlockerListEdit = false;
                  }).catch( error =>
                  {
                    alert("Ein Fehler ist aufgetreten: " +error);
                    console.log(error);
                  });
                }
            }
        },
        mounted() {
            Promise.all( [
                '/mds/blocker_list'
              , '/mds/country'
              , '/mds/market'
              , '/mds/region'
              , '/mds/evaluation_job'
              , '/user/self'
              ].map(s => axios.get(s))
            ).then( ([blockerLists, countries, markets, regions, evaluationJobs, _user]) => {
                this.finishedLoading = true;

                this.blockerLists = blockerLists.data.map( blockerList => {
                  blockerList.payload = blockerList.payload.join('\n');
                  blockerList.evaluationJob = evaluationJobs.data.filter( ej => ej.blockerListId === blockerList.id ).sort((a, b) => { return a.id >= b.id });
                  blockerList.evaluationJob = (blockerList.evaluationJob.length > 0) ? blockerList.evaluationJob[blockerList.evaluationJob.length - 1] : null;
                  return blockerList;
                });
                this.timer = setInterval(this.fetchData, 9000);

                this.countries = countries.data;
                this.markets = markets.data;
                this.regions = regions.data;
                this.user = _user.data;
                this.marketSelectOptions = this.markets.map( x => {
                    return {
                        value: x.id,
                        text: x.name
                    }});

                this.countrySelectOptions = this.countries.map( x => {
                    return {
                        value: x.id,
                        text: x.name
                    }});

                this.regionSelectOptions = this.regions.map( x => {
                    return {
                        value: x.id,
                        text: x.name
                    }
                });
            })
            .catch( error =>
                console.log(error)
            );
        },
        beforeUnmount () {
          clearInterval(this.timer);
        }
    }
</script>
